module.exports = __webpack_public_path__ + "img/142.e34d3a1.jpg";